// extracted by mini-css-extract-plugin
module.exports = {"large-number-input":"styles_large-number-input__dqqHe","small-number-input":"styles_small-number-input__rsKBs"};